import axios from 'axios';
import config from './config'
import Vue from "vue";
import chatDataCenter from "../jsSdk/chatDataCenter";
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

/**
 * axios拦截器更优雅 暂未实现
 */

let http = axios.create({
    baseURL: config.baseUrl,
    // withCredentials: true,
});
let unLoadList=['/chatCustomer/refreshRobotTimes','setNotice/getNoticeByChannelId']

function apiManage(method,headers, url, params, response) {
    // http.defaults.headers.common['token'] = userInfo.getToken();
    if(unLoadList.indexOf(url)==-1){
        chatDataCenter.loadPage.requestLoad=true
    }
    console.log('web【'+url+'】')
    var requestHeaders={
        method: method,
        url: url,
        data: method === 'POST' || method === 'PUT' ? params : null,
        params: method === 'GET' || method === 'DELETE' ? params : null
    }
    if (headers!=null){
        requestHeaders.headers={
            'Content-Type': headers,
        };
        if (headers=='application/json;charset=UTF-8'){
            requestHeaders.transformRequest=[function (data) {
                return data;
            }]
        }
    }else {
        requestHeaders.headers={
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        };
        requestHeaders.transformRequest=[function (data) {
            let newData = '';
            for (let k in data) {
                if (data.hasOwnProperty(k) === true) {
                    newData += encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) + '&';
                }
            }
            return newData;
        }]
    }
    http(requestHeaders).then(function (res) {
        console.log(res.data);
        if(res.data.code == -1 && res.data.msg == "token未授权"){
            // userInfo.destroy();
            // router.push('/login');
        }else{
            response(res.data);
        }
        if (chatDataCenter.showChatPage){
            chatDataCenter.loadPage.requestLoad=false
        }
    }).catch(function (res) {
        if (res instanceof Error) {
            response({ msg:"网络异常",code:-1});
        } else {
            response(res);
        }
        if (chatDataCenter.showChatPage){
            chatDataCenter.loadPage.requestLoad=false
        }
    })
}

function apiRobotCloudJsonp( url, params, response) {
    Vue.jsonp(config.cloudHost+url,params).then(json => {
         response({ data:json,success:true});
    }).catch(err => {
        if (err instanceof Error) {
            response({ message:"网络异常",status:false});
        } else {
            response({ data:err,success:false});
        }
    })
}

function apiRobot(method,baseURL, url, params, response) {
    console.log('apiRobot【'+baseURL+url+'】')
    http({
        method: method,
        url: url,
        data: method === 'POST' || method === 'PUT' ? params : null,
        params: method === 'GET' || method === 'DELETE' ? params : null,
        baseURL: baseURL,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        },
        transformRequest: [function (data) {
            return JSON.stringify(data);
        }]
    }).then(function(res) {
        console.log(res)
        if(res.status!=200){
            response({ message:"网络异常1",success:false});
        }else{
            response({ data:res.data,success:true});
        }
    }).catch(function(err) {
        if (err instanceof Error) {
            response({ message:"网络异常2",success:false});
        } else {
            response({ message:"网络异常3",success:false});
        }
    })
}

export default {
    get: function (url, params, response) {
        return apiManage('GET', null,url, params, response)
    },
    post: function (url, params, response) {
        return apiManage('POST',null, url, params, response)
    },
    postFile: function (url, params, response) {
        return apiManage('POST', 'multipart/form-data',url, params, response)
    },
    getCloudJsonp: function (url, params, response) {
        return apiRobotCloudJsonp( url, params, response)
    },
    postCloud: function (url, params, response) {
        return apiRobot('POST', config.cloudHost, url, params, response)
    },
    getCloud: function (url, params, response) {
        return apiRobot('GET', config.cloudHost, url, params, response)
    },
    postApi: function (url, params, response) {
        return apiRobot('POST', config.apiHost, url, params, response)
    },
}
